// extracted by mini-css-extract-plugin
export default {"container":"T1-z"};